<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>项目</el-breadcrumb-item>
        <el-breadcrumb-item>分销推广</el-breadcrumb-item>
        <el-breadcrumb-item>推广人员</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">人员审核</h2>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item
          label="用户信息"
          prop="name"
        >
          <el-input
            v-model="query.user_keyword"
            placeholder="输入用户ID/姓名/手机号"
            @input="fetchList()"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">人员列表</h3>
        <el-form
          label-width="70px"
          size="small"
        >
          <el-form-item style="">
            <el-radio-group
              v-model="radio"
              @change="radioChange"
            >
              <el-radio-button
                v-for="(item, index) in filter.status"
                :key="index"
                :label="item.value"
              >
                {{ item.label }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="uid"
            label="用户ID"
            width="80px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="user_nickname"
            label="姓名"
            width="120px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="mobile"
            label="手机号"
            width="120px"
            align="center"
          >
            <template slot-scope="scope">
              {{scope.row.mobile?scope.row.mobile:'无'}}
            </template>
          </el-table-column>
          <el-table-column
            prop="inviter_nickname"
            label="邀请人"
            width="120px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="inviter_name"
            label="状态"
            width="120px"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                size="mini"
                type="warning"
                v-if="[0,1,2].includes(scope.row.promoter_type)"
              >未审核</el-tag>
              <el-tag
                size="mini"
                type="success"
                v-if="[3,4].includes(scope.row.promoter_type)"
              >已审核</el-tag>
              <el-tag
                size="mini"
                type="danger"
                v-if="[5,6].includes(scope.row.promoter_type)"
              >{{scope.row.promoter_type==5?'已拒绝':'已清退'}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="推广员优势"
            width="260px"
            align="left"

          >
            <template slot-scope="scope">

              <el-popover
                placement="top-start"
                title=""
                width="200"
                trigger="hover"
                :content="scope.row.advantage"
                :popper-class="popperClass"
              >
                <el-button
                  slot="reference"
                  size="mini"
                >{{scope.row.advantage?scope.row.advantage:'无'}}</el-button>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            label="本科院校"
            width="180px"
            align="center"
          >
            <template slot-scope="scope">
              {{scope.row.regular_college_name?scope.row.regular_college_name:'无'}}
            </template>
          </el-table-column>
          <el-table-column
            label="本科专业"
            width="180px"
            align="center"
          >
            <template slot-scope="scope">
              {{scope.row.regular_major_code?`(${scope.row.regular_major_code})${scope.row.regular_major_name}`:'无'}}
            </template>
          </el-table-column>
          <el-table-column
            label="考研院校"
            width="180px"
            align="center"
          >
            <template slot-scope="scope">
              {{scope.row.master_college_name?scope.row.master_college_name:'无'}}
            </template>
          </el-table-column>
          <el-table-column
            label="考研专业"
            width="180px"
            align="center"
          >
            <template slot-scope="scope">
              {{scope.row.master_major_code?`(${scope.row.master_major_code})${scope.row.master_major_name}`:'无'}}
            </template>
          </el-table-column>

          <el-table-column
            label="申请日期"
            width="120px"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY.MM.DD")
              }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            width="120px"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <div v-if="[1,2].includes(scope.row.promoter_type)">
                <el-link
                  type="primary"
                  :underline="false"
                  @click="handelToAccept(scope.row)"
                >同意</el-link>
                <el-link
                  type="danger"
                  :underline="false"
                  @click="openReasonDialog(scope.row)"
                >拒绝</el-link>
              </div>
              <div v-else>
                <el-link
                  type="primary"
                  :underline="false"
                  @click="handelToAccept(scope.row)"
                >同意</el-link>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="拒绝理由"
      :visible="dialogVisible"
      width="500px"
    >
      <el-form
        :model="form"
        ref="dialogForm"
        :rules="rules"
      >
        <el-form-item prop="refuse_reason">
          <el-input
            type="textarea"
            v-model="form.refuse_reason"
          ></el-input>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submit('dialogForm')"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { promoterlist, memberpromoterEdit, promotercheck } from "@/api/distribution";
export default {
  components: {

  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
        promoter_type: "1,2"
      },
      pageTotal: 10,
      results: [],
      filter: {
        status: [
          { label: "待审核", value: "1" },
          { label: "已拒绝", value: "0" },
        ],
      },
      radio: "1",
      form: {},
      dialogVisible: false,
      rules: {
        refuse_reason: [
          { required: true, message: "请输入拒绝理由", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.fetchList()
  },
  methods: {
    radioChange(e) {
      switch (e) {
        case "1":
          this.query.promoter_type = [1, 2].join(',')
          this.fetchList()
          break;
        case "0":
          this.query.promoter_type = "5"
          this.fetchList()
          break;
        default:
          break;
      }
    },
    fetchList() {
      promoterlist(this.query).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchList();
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      this.fetchList();
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      );
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        });
    },
    handelToClear(row) {
      // 二次确认删除
      this.$confirm('确定要清退吗？', '提示', {
        type: 'warning'
      }).then(() => {
        memberpromoterEdit({ id: row.id, promoter_type: 6 }).then(res => {
          this.$message.success(`清退成功`)
          this.fetchList()
        })
      }).catch(() => { })
    },
    handelToAccept(row) {
      // 二次确认删除
      this.$confirm('确定审核通过吗？', '提示', {
        type: 'warning'
      }).then(() => {
        promotercheck({ id: row.id, is_pass: 1 }).then(res => {
          this.$message.success(`操作成功`)
          this.fetchList()
        })
      }).catch(() => { })
    },
    openReasonDialog(row) {
      this.form = JSON.parse(JSON.stringify(row))
      this.dialogVisible = true
    },
    submit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          let query = {
            refuse_reason: this.form.refuse_reason,
            id: this.form.id,
            is_pass: 0
          };
          promotercheck(query).then((res) => {
            this.$nextTick(() => {
              this.dialogVisible = false;
              this.$message.success(`操作成功`)
              this.fetchList()
            });
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
.el-link {
  font-size: 12px;
  margin: 0px 5px;
}
.el-button {
  border: none;
}
</style>
